function exportCSVFile({
    headers,
    items,
    fileName,
    delimiter = ",",
    stringDelimiter = "'",
}) {
    if (headers) {
        items.unshift(headers);
    }
    // Convert Object to JSON
    var jsonObject = JSON.stringify(items);
    var csv = convertToCSV({
        objArray: jsonObject,
        delimiter,
        stringDelimiter,
    });

    var exportedFilename = fileName ? fileName + ".csv" : "export.csv";

    var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFilename);
    } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
            // feature detection
            // Browsers that support HTML5 download attribute
            var url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", exportedFilename);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
}

function convertToCSV({ objArray, delimiter, stringDelimiter }) {
    var array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    var str = "";

    for (var i = 0; i < array.length; i++) {
        var line = "";
        for (var index in array[i]) {
            if (line != "") line += delimiter;
            let value = array[i][index];
            if(typeof value === "string") {
                if (value.includes(delimiter) || value.includes('\n') || value.includes('\r')) {
                    value = stringDelimiter + value + stringDelimiter;
                }
            }
            line += value;
        }

        str += line + "\r\n";
    }

    return str;
}

function adapterHeadersAsJsonFromTableFields(fields) {
    let headers = {};
    for (let i = 0; i < fields.length; i++) {
        const field = fields[i];
        if (!field.key.startsWith("_")) {
            headers = {
                ...headers,
                [field.key]: field.label,
            };
        }
    }
    return headers;
}

function adapterTableItemsFromHeaders(items, headers) {
    let adaptedItems = [];
    for (let index = 0; index < items.length; index++) {
        const item = items[index];
        let tempItem = {};
        for (let key in headers) {
            tempItem = {
                ...tempItem,
                [key]: item[key],
            };
        }
        adaptedItems.push(tempItem);
    }
    return adaptedItems;
}

export {
    exportCSVFile,
    convertToCSV,
    adapterHeadersAsJsonFromTableFields,
    adapterTableItemsFromHeaders,
};
